import { BlobServiceClient } from '@azure/storage-blob';
import { getPresignedURl } from 'services/storage.service';

// Helper function to read file content and convert it to a buffer
const readFileAsBuffer = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(Buffer.from(reader.result));
    reader.onerror = (error) => reject(error);
    reader.readAsArrayBuffer(file);
});

export const uploadFile = async (file, path = '') => {
    const containerName = process.env.NEXT_PUBLIC_BLOB_STORAGE_CONTAINER_NAME;

    if (!file) return null; // Return early if no file provided

    const fileNameSplit = file?.name?.split('.') ?? []

    const fileExt = fileNameSplit[fileNameSplit.length - 1]

    const newFileName = `${path}${file.name.replace(`.${fileExt}`, '')}_${Date.now()}.${fileExt}`;

    try {
    // Get the pre-signed URL for uploading the file
        const presignedUrl = await getPresignedURl(newFileName);

        if (presignedUrl?.status) {
            const endpoint = presignedUrl.entity;

            // Read the file content and convert it to a buffer
            const buffer = await readFileAsBuffer(file);

            // Initialize BlobServiceClient and get ContainerClient
            const blobService = new BlobServiceClient(endpoint);
            const containerClient = blobService.getContainerClient(containerName);

            // Upload the buffer to Azure Blob Storage
            const blobClient = containerClient.getBlockBlobClient(newFileName);
            const response = await blobClient.upload(buffer, buffer.length);
            // Return the response data
            if (!response) return null;
            return { ...response, key: newFileName };
        }
        throw new Error('Failed to get pre-signed URL');
    } catch (error) {
        console.error('Error uploading file:', error);
        return null; // Return null if an error occurs
    }
};

export default uploadFile;
